/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Location = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 10 15" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M10 5.3A5.18 5.18 0 0 0 5 0a5.21 5.21 0 0 0-5 5.33c0 3.17 4.42 9.34 4.42 9.34A.8.8 0 0 0 5 15a.8.8 0 0 0 .59-.36S10 8.5 10 5.3zM5 3.16a2 2 0 0 1 1.92 2 2 2 0 0 1-1.92 2 2 2 0 0 1-1.91-2 2 2 0 0 1 1.91-2" />
      </g>
    </svg>
  </span>
);

Location.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Location.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Location;
